import { render, staticRenderFns } from "./orgTypeTreePage.vue?vue&type=template&id=7ec4697c&scoped=true&"
import script from "./orgTypeTreePage.vue?vue&type=script&lang=js&"
export * from "./orgTypeTreePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec4697c",
  null
  
)

export default component.exports